export function paymentExportParams(params = {}) {
  const { offset, limit, selected, ...filters } = params
  return filters
}
